import React, { useState } from 'react';
// Note: We don't need 'useNavigate' on this page, but the
// 'MedicalSupport.js' page will need it to link here.

// --- Patient Data for this Detail Page (UPDATED from PDFs) ---
const patientDetailData = {
  id: 1,
  name: "Master Leonel Thomas A",
  disease: "Spinal Muscular Atrophy (SMA) Type 1",
  imageUrl: "/patient1.jpeg", 
  logoUrl: "https://indianwelfarefoundation11.s3.ap-south-1.amazonaws.com/logo192.png",
  

  goalAmount: "₹ 16,00,000,00",
  raisedAmount: "₹ 1,20,000", 
  goalAmountRaw: 160000000,
  raisedAmountRaw: 120000,

problemDescription: `Master Leonel Thomas A, a 2.5-year-old boy, is battling Spinal Muscular Atrophy (SMA) Type 1, a rare and life-threatening genetic disorder. 

Dr. Ann Agnes Mathew, a Paediatric Neurologist at Bangalore Baptist Hospital, has certified this as a progressive and fatal disease. 

A DNA test report from Medgenome Labs confirms the diagnosis, showing a pathogenic "homozygous deletion of exons 7 and 8 in the SMN1 gene", which is the primary cause of SMA.

The only life-saving treatment is a one-time gene therapy infusion called Zolgensma (AVXS-101). 

This medicine is not manufactured in India and must be imported. The total cost is staggering, estimated at approximately **16,00,00,000 (Sixteen Crores INR)**.

The treatment is extremely time-sensitive. Leonel's father, Mr. Ajay Sylvester, has authorized the Indian Welfare Foundation to raise funds for his son's treatment. Your contribution is urgently needed to give this young boy a chance at life.`,

  // New Supporting Documents (Paths as provided by you)
  supportingDocuments: [
    {
      id: 'doc1',
      type: 'pdf',
      title: 'Hospital Report', // Zolgensma.pdf
      url: '/Zolgensma .pdf'
    },
    {
      id: 'doc2',
      type: 'pdf',
      title: 'Diagnosis Scan', // Medgenome.pdf
      url: '/Medgenome.pdf'
    },
    {
      id: 'doc3',
      type: 'pdf',
      title: 'Cost Estimate', // sign.pdf
      url: '/sign.pdf'
    }
  ]
};


export default function PatientDetailPage() {
  // --- UPDATED: State now uses string to allow for empty field ---
  const [amount, setAmount] = useState('3000'); 
  const [formData, setFormData] = useState({
    fullName: '',
    dob: '',
    email: '',
    phone: '',
    city: '',
    pan: '',
    category: '',
  });

  // State for the "Show More" toggle
  const [isExpanded, setIsExpanded] = useState(false);

  // --- Form Handlers (Copied from MedicalSupport) ---

  const handleAmountClick = (newAmount) => {
    // --- UPDATED: Set amount as string ---
    setAmount(String(newAmount));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // --- UPDATED: Handle text input, only allowing numbers ---
  const handleCustomAmountChange = (e) => {
    const value = e.target.value;
    // Regex to allow only numbers (or an empty string)
    if (/^[0-9]*$/.test(value)) {
      setAmount(value);
    }
  };

  // --- NEW: Handler for "Other" button ---
  const handleOtherAmountClick = () => {
    setAmount(''); // Set to empty string
  };

  // --- UPDATED: Razorpay Payment Page Redirect ---
  
  const handleDonateNow = (e) => {
    e.preventDefault();

    // 1. Define your Payment Page URL
    const baseUrl = 'https://pages.razorpay.com/pl_Rev3D03XVlNP8t/view';

    // 2. Get data from state and format it for the URL
    // Amount is multiplied by 1 to convert string/empty string to a number
    // This will send '0' if the amount is empty, which Razorpay handles.
    const amountInRs = amount * 1;
    
    // Encode strings to make them safe for a URL
    const name = encodeURIComponent(formData.fullName);
    const email = encodeURIComponent(formData.email);
    const phone = encodeURIComponent(formData.phone); // Razorpay uses 'contact'
    const city = encodeURIComponent(formData.city);
    const Pan_No = encodeURIComponent(formData.pan);
    
    // 3. Build the query string with pre-filled data
    // NOTE: Razorpay Payment Pages expect 'amount' in Rupees, not paise, when passed in URL
    const queryParams = `?amount=${amountInRs}&name=${name}&email=${email}&phone=${phone}&city=${city}&pan_no=${Pan_No}`;

    // 4. Redirect the user to the Razorpay Page
    window.location.href = baseUrl + queryParams;
  };
  
  // Calculate progress percentage
  const progressPercent = (patientDetailData.raisedAmountRaw / patientDetailData.goalAmountRaw) * 100;


  return (
    <>
      {/* --- Custom CSS for this component (with unique 'ms-' prefix) --- */}
      <style>
        {`
          /* Box Sizing */
          .ms-section *, .ms-section *::before, .ms-section *::after {
            box-sizing: border-box;
          }

          /* General Section */
          .ms-section {
            padding: 60px 0;
            background-color: #f9f9f9;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
            line-height: 1.6;
          }
          
          /* Layout: Container */
          .ms-main-container {
            max-width: 1140px;
            margin-right: auto;
            margin-left: auto;
            padding-right: 15px;
            padding-left: 15px;
          }

          /* Layout: Grid Row */
          .ms-layout-grid {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin-right: -24px;
            margin-left: -24px;
          }

          /* Layout: Grid Columns */
          .ms-grid-left,
          .ms-grid-right {
            width: 100%;
            padding-right: 24px;
            padding-left: 24px;
            margin-bottom: 2rem;
          }

          /* --- Left Side: Patient Details --- */
          .ms-patient-card { /* Re-using this style for the image container */
            border: 1px solid #ddd;
            border-radius: 10px;
            overflow: hidden;
            background-color: #fff;
            box-shadow: 0 4px 10px rgba(0,0,0,0.05);
            margin-bottom: 1.5rem; /* Added margin */
          }
          .ms-patient-image-wrapper {
            position: relative;
          }
          .ms-patient-image-wrapper img.ms-patient-image {
            width: 100%;
            height: auto;
            display: block;
          }
          .ms-patient-logo {
            position: absolute;
            top: 15px;
            left: 15px;
            width: 150px;
            height: auto;
            background-color: rgba(255, 255, 255, 0.7);
            border-radius: 5px;
            padding: 5px;
          }
          .ms-patient-details {
            padding: 20px;
            text-align: center;
          }
          .ms-patient-details h5 {
            font-weight: 700;
            color: #333;
            margin-top: 0;
            margin-bottom: 5px;
            font-size: 1.25rem;
          }
          .ms-patient-details p {
            font-size: 1rem;
            color: #E76F51;
            font-weight: 600;
            margin: 0;
          }
          
          /* --- NEW: Progress Card --- */
          .ms-progress-card {
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 10px;
            padding: 25px;
            margin-bottom: 1.5rem;
            box-shadow: 0 4px 10px rgba(0,0,0,0.05);
          }
          .ms-progress-info {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            margin-bottom: 1rem;
          }
          .ms-progress-raised, .ms-progress-goal {
            font-size: 1.1rem;
            font-weight: 700;
            color: #333;
          }
          .ms-progress-label {
            font-size: 0.9rem;
            color: #555;
            margin-bottom: 4px;
          }
          .ms-progress-goal {
            font-size: 1.5rem;
            color: #E76F51;
            text-align: right;
          }
          .ms-progress-bar-container {
            width: 100%;
            height: 10px;
            background-color: #e9ecef;
            border-radius: 5px;
            overflow: hidden;
          }
          .ms-progress-bar-filled {
            height: 100%;
            background-color: #E76F51;
            border-radius: 5px;
            transition: width 0.5s ease-in-out;
          }

          /* NEW: Problem Description */
          .ms-description-box {
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 10px;
            padding: 25px;
            margin-bottom: 1.5rem;
            box-shadow: 0 4px 10px rgba(0,0,0,0.05);
          }
          .ms-description-box h4 {
            font-weight: 700;
            color: #333;
            font-size: 1.2rem;
            margin-top: 0;
            margin-bottom: 1rem;
            border-bottom: 2px solid #E76F51;
            padding-bottom: 5px;
          }
          .ms-patient-description {
            color: #555;
            position: relative;
            overflow: hidden;
            transition: max-height 0.5s ease-out;
            white-space: pre-line; /* This will respect line breaks in the string */
          }
          .ms-description-collapsed {
            max-height: 100px; /* Show limited content */
          }
          .ms-description-expanded {
            max-height: 1000px; /* Allow full content */
          }
          .ms-show-more-btn {
            background: none;
            border: none;
            color: #0d6efd;
            font-weight: 700;
            cursor: pointer;
            padding: 5px 0;
            margin-top: 10px;
          }
          
          /* NEW: Supporting Documents */
          .ms-documents-section {
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 10px;
            padding: 25px;
            box-shadow: 0 4px 10px rgba(0,0,0,0.05);
          }
          .ms-documents-section h4 {
            font-weight: 700;
            color: #333;
            font-size: 1.2rem;
            margin-top: 0;
            margin-bottom: 1.5rem;
            border-bottom: 2px solid #E76F51;
            padding-bottom: 5px;
          }
          .ms-document-gallery {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
            gap: 20px;
          }
          .ms-document-item {
            text-align: center;
          }
          .ms-document-item img {
            width: 100%;
            height: 100px;
            object-fit: cover;
            border-radius: 8px;
            border: 1px solid #eee;
            cursor: pointer;
            transition: transform 0.2s;
          }
          .ms-document-item img:hover {
            transform: scale(1.05);
          }
          .ms-document-pdf-link {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100px;
            border-radius: 8px;
            background-color: #f4f4f4;
            border: 1px solid #eee;
            text-decoration: none;
            color: #E76F51;
            font-weight: 600;
            transition: background-color 0.2s;
          }
          .ms-document-pdf-link:hover {
            background-color: #e9e9e9;
          }
          .ms-document-pdf-link svg { /* Simple PDF Icon */
            width: 32px;
            height: 32px;
            margin-bottom: 8px;
            fill: #E76F51;
          }
          .ms-document-title {
            font-size: 0.9rem;
            font-weight: 600;
            color: #444;
            margin-top: 8px;
          }


          /* --- Right Side: Donation Form (Styles reused from MedicalSupport) --- */
          .ms-form-container {
            border: 2px dashed #E76F51;
            padding: 30px;
            border-radius: 10px;
            background-color: #fff;
            position: sticky; /* Make form sticky */
            top: 20px;
          }
          .ms-form-title {
            font-size: 1.5rem;
            font-weight: 700;
            color: #E76F51;
            margin-bottom: 20px;
            text-align: center;
            margin-top: 0;
          }
          .ms-amount-buttons-container { display: flex; justify-content: space-between; margin-bottom: 1rem; }
          .ms-amount-btn { flex-grow: 1; margin-right: 8px; padding: 0.75rem 1rem; font-size: 1rem; background-color: #f0f0f0; border: 1px solid #ddd; color: #333; border-radius: 5px; cursor: pointer; text-align: center; transition: background-color 0.2s, color 0.2s; }
          .ms-amount-btn:last-child { margin-right: 0; }
          .ms-amount-btn.ms-btn-active { background-color: #0d6efd; color: white; border-color: #0d6efd; }
          .ms-input-group { position: relative; display: flex; flex-wrap: wrap; align-items: stretch; width: 100%; margin-bottom: 1rem; }
          .ms-input-group-text { display: flex; align-items: center; padding: 0.5rem 0.75rem; font-size: 1rem; font-weight: 400; line-height: 1.5; color: #212529; text-align: center; white-space: nowrap; background-color: #e9ecef; border: 1px solid #ced4da; border-radius: 5px; border-top-right-radius: 0; border-bottom-right-radius: 0; }
          .ms-input-group .ms-form-input { position: relative; flex: 1 1 auto; width: 1%; min-width: 0; border-top-left-radius: 0; border-bottom-left-radius: 0; }
          .ms-form-input, .ms-form-select { display: block; width: 100%; padding: 0.5rem 0.75rem; font-size: 1rem; font-weight: 400; line-height: 1.5; color: #212529; background-color: #fff; background-clip: padding-box; border: 1px solid #ced4da; border-radius: 5px; transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out; }
          .ms-form-input:focus, .ms-form-select:focus { color: #212529; background-color: #fff; border-color: #86b7fe; outline: 0; box-shadow: 0 0 0 0.25rem rgba(13,110,253,.25); }
          .ms-form-row { display: flex; flex-wrap: wrap; margin-right: -6px; margin-left: -6px; }
          .ms-form-col-12, .ms-form-col-6 { width: 100%; padding-right: 6px; padding-left: 6px; margin-bottom: 1rem; }
          .ms-form-text { font-size: 0.875em; color: #6c757d; margin-top: 1rem; margin-bottom: 1rem; }
          .ms-form-check { display: block; min-height: 1.5rem; padding-left: 1.5em; margin-bottom: 1.5rem; }
          .ms-form-check-input { float: left; margin-left: -1.5em; width: 1em; height: 1em; margin-top: 0.25em; vertical-align: top; background-color: #fff; border: 1px solid rgba(0,0,0,.25); border-radius: 0.25em; }
          .ms-form-check-label { display: inline-block; padding-left: 0.5em; font-size: 0.9rem; }
          .ms-donate-btn { background-color: #6a1b9a; color: white; font-weight: 700; border: none; width: 100%; padding: 12px; font-size: 1rem; border-radius: 5px; cursor: pointer; transition: background-color 0.3s; }
          .ms-donate-btn:hover { background-color: #4a148c; }
          .ms-mb-3 { margin-bottom: 1rem !important; }
          .ms-mb-4 { margin-bottom: 1.5rem !important; }
          .ms-text-center { text-align: center !important; }

          /* Responsive Breakpoints */
          @media (min-width: 768px) {
            .ms-form-col-6 {
              width: 50%;
            }
          }
          @media (min-width: 992px) {
            .ms-grid-left {
              flex: 0 0 auto;
              width: 58.333333%; /* 7/12 */
            }
            .ms-grid-right {
              flex: 0 0 auto;
              width: 41.666667%; /* 5/12 */
            }
          }
        `}
      </style>

      {/* --- JSX Markup (using unique 'ms-' classes) --- */}
      <div className="ms-section">
        <div className="ms-main-container">
          <div className="ms-layout-grid">
            
            {/* --- Left Side: Patient Details --- */}
            <div className="ms-grid-left">
              
              {/* Patient Image Box */}
              <div className="ms-patient-card">
                <div className="ms-patient-image-wrapper">
                  <img 
                    src={patientDetailData.imageUrl} 
                    alt={patientDetailData.name} 
                    className="ms-patient-image" 
                  />
                  <img 
                    src={patientDetailData.logoUrl} 
                    alt="Logo" 
                    className="ms-patient-logo" 
                  />
                </div>
                <div className="ms-patient-details">
                  <h5>{patientDetailData.name}</h5>
                  <p>Disease: {patientDetailData.disease}</p>
                </div>
              </div>

              {/* --- NEW: Fundraiser Progress Card --- */}
              <div className="ms-progress-card">
                <div className="ms-progress-info">
                  {/* <div className="ms-progress-raised">
                    <div className="ms-progress-label">Raised</div>
                    {patientDetailData.raisedAmount}
                  </div> */}
                  <div className="ms-progress-goal">
                    <div className="ms-progress-label">Amount to Save a Life</div>
                    {patientDetailData.goalAmount}
                  </div>
                </div>
                {/* <div className="ms-progress-bar-container">
                  <div 
                    className="ms-progress-bar-filled"
                    style={{ width: `${progressPercent}%` }}
                  ></div>
                </div> */}
              </div>
              
              {/* Problem Description Box */}
              <div className="ms-description-box">
                <h4>Problem Description</h4>
                <p className={`ms-patient-description ${isExpanded ? 'ms-description-expanded' : 'ms-description-collapsed'}`}>
                  {patientDetailData.problemDescription}
                </p>
                <button 
                  className="ms-show-more-btn"
                  onClick={() => setIsExpanded(!isExpanded)}
                >
                  {isExpanded ? 'Show Less' : 'Show More...'}
                </button>
              </div>

              {/* Supporting Documents Box */}
              <div className="ms-documents-section">
                <h4>Supporting Documents</h4>
                <div className="ms-document-gallery">
                  {patientDetailData.supportingDocuments.map(doc => (
                    <div key={doc.id} className="ms-document-item">
                      {doc.type === 'image' ? (
                        <img 
                          src={doc.url} 
                          alt={doc.title} 
                          onClick={() => window.open(doc.url, '_blank')} // Open image in new tab
                        />
                      ) : (
                        <a 
                          href={doc.url} 
                          target="_blank" 
                          rel="noopener noreferrer" 
                          className="ms-document-pdf-link"
                        >
                          {/* Simple PDF SVG Icon */}
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM9.5 18H8v-3h1.5v3zm3 0h-1.5v-3H11v1.5h1.5v-1.5H14v3h-1.5v-1.5h-1.5v1.5zm3-5.5H8v-1.5h7.5v1.5zM13 9V3.5L18.5 9H13z"/>
                          </svg>
                          PDF
                        </a>
                      )}
                      <p className="ms-document-title">{doc.title}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* --- Right Side: Donation Form --- */}
            <div className="ms-grid-right">
              <div className="ms-form-container">
                <h3 className="ms-form-title">Medical Support</h3>
                
                {/* --- UPDATED FORM ACTION --- */}
                <form onSubmit={handleDonateNow}>
                  
                  {/* --- UPDATED: Amount Buttons --- */}
                  <div className="ms-amount-buttons-container">
                    <button 
                      type="button" 
                      className={`ms-amount-btn ${amount === '3000' ? 'ms-btn-active' : ''}`}
                      onClick={() => handleAmountClick(3000)}
                    >
                      ₹ 3000
                    </button>
                    <button 
                      type="button" 
                      className={`ms-amount-btn ${amount === '5000' ? 'ms-btn-active' : ''}`}
                      onClick={() => handleAmountClick(5000)}
                    >
                      ₹ 5000
                    </button>
                    {/* --- NEW: "Other" Button --- */}
                    <button 
                      type="button" 
                      className={`ms-amount-btn ${amount !== '3000' && amount !== '5000' ? 'ms-btn-active' : ''}`}
                      onClick={handleOtherAmountClick}
                    >
                      Other
                    </button>
                  </div>
                  
                  {/* --- UPDATED: Custom Amount Input --- */}
                  <div className="ms-input-group">
                    <span className="ms-input-group-text">₹</span>
                    <input 
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      className="ms-form-input" 
                      value={amount}
                      onChange={handleCustomAmountChange}
                      placeholder="Enter amount" 
                    />
                  </div>

                  <p className="ms-mb-3">Fill more information</p>

                  {/* Form Fields */}
                  <div className="ms-form-row">
                    <div className="ms-form-col-12">
                      <input 
                        type="text" 
                        className="ms-form-input" 
                        placeholder="Enter Full name *" 
                        name="fullName"
                        value={formData.fullName}
                        onChange={handleInputChange}
                        required 
                      />
                    </div>
                    {/* <div className="ms-form-col-6">
                      <input 
                        type="text" 
                        className="ms-form-input" 
                        placeholder="DOB mm/dd/yyyy"
                        name="dob"
                        value={formData.dob}
                        onChange={handleInputChange}
                        onFocus={(e) => e.target.type = 'date'}
                        onBlur={(e) => e.target.type = 'text'}
                      />
                    </div> */}
                    <div className="ms-form-col-12">
                      <input 
                        type="email" 
                        className="ms-form-input" 
                        placeholder="Enter Email" 
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="ms-form-col-12">
                      <div className="ms-input-group">
                        <span className="ms-input-group-text">+91</span>
                        <input 
                          type="tel" 
                          className="ms-form-input" 
                          placeholder="Enter Phone *" 
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          required 
                        />
                      </div>
                    </div>
                    <div className="ms-form-col-6">
                      <input 
                        type="text" 
                        className="ms-form-input" 
                        placeholder="City" 
                        name="city"
                        value={formData.city}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="ms-form-col-6">
                      <input 
                        type="text" 
                        className="ms-form-input" 
                        placeholder="Pan No." 
                        name="pan"
                        value={formData.pan}
                        onChange={handleInputChange}
                      />
                    </div>
                     {/*<div className="ms-form-col-12">
                      <select 
                        className="ms-form-select"
                        name="category"
                        value={formData.category}
                        onChange={handleInputChange}
                      >
                        <option value="">Choose Category</option>
                        <option value="medical">Medical</option>
                        <option value="education">Education</option>
                        <option value="general">General</option>
                      </select>
                    </div> */}
                  </div>

                  {/* 80G Notice */}
                  {/* <div className="ms-form-text">
                    PLEASE PROVIDE PAN NUMBER TO CLAIM THE BENEFITS OF 80G RECEIPT AS PER GOVERNMENT NORMS.
                    <br/>
                    *YOUR CONTRIBUTIONS ARE ELGIBLE FOR UPTO 50% TAX BENEFIT UNDER SECTION 80G*
                  </div> */}

                  {/* Agreement Checkbox */}
                  <div className="ms-form-check">
                    <input className="ms-form-check-input" type="checkbox" id="agreeCheck" defaultChecked required />
                    <label className="ms-form-check-label" htmlFor="agreeCheck">
                      You agree that Indian Welfare Foundation can reach out to you...
                    </label>
                  </div>

                  {/* Donate Button */}
                  <button type="submit" className="ms-donate-btn">
                    Donate Now
                  </button>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}